import HorizontalScroll from '@af-common/Common/_components/HorizontalScroll'
import * as Immutable from 'immutable'
import React, { useState, useEffect } from 'react'
import ModuleContainer from '../../Module/_containers/ModuleContainer'
import UseMouseCoords from '@af-common/Common/Utils/useMouseCoords'

// All magic here so it's easier to change in the future
const MODULE_WIDTH: number = 168
const LEFT_PADDING: number = 56
const TOP_PADDING: number = 8

export type Props = {
	moduleIds?: Immutable.OrderedSet<string>
	selectedModuleId?: string
	moveModule?: (moduleId: string, position:number) => void
}

export default (props:Props) => {
	const [containerRef, setContainerRef] = useState(undefined);
	const [dragging, setDragging] = useState(null)
	const [clickCoords, setClickCoords] = useState<{x: number, y: number}>({x: 0, y: 0})
	const mouseCoords = UseMouseCoords()

	useEffect(() => {
		window.addEventListener("mouseup", () => setDragging(null));
		return () => {window.removeEventListener("mouseup", () => setDragging(null))};
	});

	if(!props.moduleIds || !props.moduleIds.size) return <></>

	const containerOffset = containerRef?.current?.scrollLeft || 0

	const moduleMouseDown = (module: string, coords: {x: number, y: number}) => {
		let index = props.moduleIds.valueSeq().keyOf(module)
		coords.x += - LEFT_PADDING - (MODULE_WIDTH * index)
		coords.y += - TOP_PADDING

		setDragging(module)
		setClickCoords(coords)
	}

	const getModule = (id:string, clone: boolean = false) => {
		const selected = id == props.selectedModuleId
		return <ModuleContainer
			isClone={clone}
			isDragging={dragging == id}
			moduleMouseDown={moduleMouseDown}
			selected={selected} 
			moduleCount={props.moduleIds.count()} 
			moduleId={id}
			key={id}
		/>
	}

	let modules = <HorizontalScroll setContainerRef={setContainerRef}>{props.moduleIds.map((id) => getModule(id)).toArray()}</HorizontalScroll>
	let clone = <></>

	if(dragging) {
		const currentIndex = props.moduleIds.valueSeq().keyOf(dragging)
		const position = {
			x: mouseCoords.x - clickCoords.x - containerOffset,
			y: mouseCoords.y - clickCoords.y
		}

		clone = <div className={"module-wrapper floating"} style={{
			zIndex: 2,
			left: position.x + 'px',
			top: position.y + 'px',
		}}>{getModule(dragging, true)}</div>

		let newIndex = Math.max(0, Math.min(Math.floor(((position.x + containerOffset - LEFT_PADDING) + (MODULE_WIDTH / 2)) / (MODULE_WIDTH)), props.moduleIds.size - 1))
		if(newIndex !== currentIndex) {
			props.moveModule(dragging, newIndex)
		}
	}

	return <div className={'modules-container'}>
		{modules}
		{clone}
	</div>
}